<template>
  <div class="schedule-list">
    <div class="table">
      <el-table :data="tableData" style="width: 100%" height="100%">
        <el-table-column type="index" :label="$t('terminal.no')" width="150">
        </el-table-column>
        <el-table-column prop="action" :label="$t('terminal.types')">
          <template slot-scope="scope">
            <template v-if="scope.row.action==2">
              {{$t('terminal.conBright')}}
            </template>
            <template v-if="scope.row.action==3">
              {{$t('terminal.action3')}}
            </template>
            <template v-if="scope.row.action==4">
              {{$t('terminal.action4')}}
            </template>
            <template v-if="scope.row.action==5">
              {{$t('terminal.action5')}}
            </template>
            <template v-if="scope.row.action==6">
              {{$t('terminal.action6')}}
            </template>
            <template v-if="scope.row.action==7">
              {{$t('terminal.action7')}}
            </template>
            <template v-if="scope.row.action==8">
              {{$t('terminal.action8')}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="value" :label="$t('terminal.value')">
          <template slot-scope="scope">
            <template v-if="scope.row.action == 6">
              <template v-if="scope.row.value == 1">
                {{$t('terminal.acVa1')}}
              </template>
              <template v-if="scope.row.value == 2">
                {{$t('terminal.acVa2')}}
              </template>
              <template v-if="scope.row.value == 3">
                {{$t('terminal.acVa3')}}
              </template>
            </template>
            <template v-else-if="scope.row.action == 7 || scope.row.action == 8">
              {{`${scope.row.pcList.length == 0 ? '无' : scope.row.pcList}`}}
            </template>
            <template v-else>
              {{scope.row.value}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="isDateLimit" :label="$t('terminal.isDateLimit')">
          <template slot-scope="scope">
            <template v-if="scope.row.isDateLimit===true">
              {{`${scope.row.dateStart}-${scope.row.dateEnd}`}}
            </template>
            <template v-else>
              {{$t('terminal.noLimit')}}
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('terminal.isWeekLimit')">
          <template slot-scope="scope">
            <template v-if="scope.row.isWeekLimit">
              <template v-if="scope.row.validWeek!=0">
                {{scope.row.weeks}}
              </template>
              <template v-else>
                {{$t('terminal.noLimit')}}
              </template>
            </template>
            <template v-else>
              {{$t('terminal.noLimit')}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" :label="$t('terminal.excTime')">
        </el-table-column>
        <el-table-column :label="$t('terminal.edits')">
          <template slot-scope="scope">
            <div class="edit">
              <img src="@/assets/images/public/public_edit.png" @click="handlePlanEdit(scope.row,scope.$index)" />
              <img src="@/assets/images/public/public_delete.png" @click="handlePlanDelete(scope.row,scope.$index)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="control">
        <div class="switch flex-c">
          <el-switch v-model="isScOpen" active-color="#13ce66" inactive-color="#ff4949" @change="changeScStatus">
          </el-switch>
          <span v-if="isScOpen">{{$t('terminal.timingOn')}}</span>
          <span v-else>{{$t('terminal.timingOff')}}</span>
        </div>
        <div class="button flex-c-c">
          <el-button type="primary" round size="mini" @click="test">{{$t('terminal.addTimingCom')}}
          </el-button>
          <!-- <el-button type="primary" round size="mini" @click="updateToTerminal">
						{{$t('terminal.syncToTerminal')}}</el-button> -->
        </div>
      </div>
    </div>
    <schedule :schduleDialog="schduleDialog" @closeSchedule="closeSchedule" :ADDEDIT="ADDEDIT" :value="schduleValue"></schedule>
  </div>
</template>

<script>
import {
  daysWeek,
  powerAndCard,
  sendCommandKp
} from "@/assets/scripts/publicFunction.js";

import {
  uriEncode
} from "@/assets/scripts/uriEncode";
import Schedule from "./Schedule.vue";
const detailCommand = "/admin/Command/deviceCommand";
const weekList = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

export default {
  name: "ScheduleList",
  props: {
    tableList: {
      type: Array
    },
    currentDetail: {
      type: Object
    }
  },
  components: {
    Schedule
  },
  data() {
    return {
      dcInfoCache: [],
      schduleDialog: false,
      tableData: [],
      inner_edit_index: null,
      weeks: weekList,
      isScOpen: false,
      validWeek: 0,
      ADDEDIT: 'ADD',
      schduleValue: {}
    }
  },
  methods: {
    test() {
      this.schduleValue = {};
      this.ADDEDIT = 'ADD'
      this.schduleDialog = true;
    },
    closeSchedule(data) {
      if (data !== 'cancel') {
        data.validWeek = parseInt(data.validWeek, 2);
        data.weeks = daysWeek(data.validWeek);
        if (data.action == 7 || data.action == 8) {
          data.pcList = powerAndCard(data.value)
        }
        if (this.ADDEDIT == 'ADD') {
          this.tableData.push(data);
        } else {
          this.$set(this.tableData, this.inner_edit_index, data);
        }
        this.updateToTerminal();
      }
      this.ADDEDIT = 'ADD'
      this.schduleDialog = false;
      this.$forceUpdate();
    },
    handlePlanDelete(row, index) {
      this.tableData.splice(index, 1);
      this.updateToTerminal();
    },
    handlePlanEdit(val, index) {
      this.inner_edit_index = index;
      this.schduleValue = val;
      this.ADDEDIT = 'EDIT'
      this.schduleDialog = true;
    },
    async updateToTerminal() {
      this.tableData.forEach((ele) => {
        delete ele.id;
        delete ele.name;
        delete ele.level;
        delete ele.isSelected;
        delete ele.scheduleEndTime;
        delete ele.scheduleStartTime;
      });
      // let res = await sendCommandKp('multiple', this.dcInfoCache, "set", this.tableData.length ? this.tableData : JSON.stringify(this.tableData), 'schedule_setting');
      let res = await sendCommandKp('multiple', this.dcInfoCache, "set", this.tableData, 'schedule_setting');
      // console.log(res);
      res.result && this.$msg({
        type: 'success',
        message: this.$t('terminal.opOk')
      });
    },
    innerConfirm() {
      let list = {};
      list.action = this.sc_action;
      // list.light = this.sc_light;
      list.startTime = this.sc_time;
      list.endTime = "00:00:00";
      list.value =
        this.sc_action == 2 || this.sc_action == 3 ? this.sc_light : 0;
      list.isDateLimit = this.sc_date_radio == "1" ? false : true;
      list.dateStart = this.sc_date_start;
      list.dateEnd = this.sc_date_end;
      list.isWeekLimit = this.sc_week_radio == "1" ? false : true;
      list.validWeek = this.validWeek;
      list.playCount = 0;
      list.name = "";
      list.id = "";
      list.weeks = daysWeek(list.validWeek);
      if (this.inner_edit_index == null) {
        this.newTemplateData = list;
        this.tableData.push(list);
        this.$forceUpdate();
        this.innerVisible = false;
      } else {
        this.$set(this.tableData, this.inner_edit_index, list);
        this.$forceUpdate();
        this.inner_edit_index = null;
        this.innerVisible = false;
      }
      this.$forceUpdate();
      this.dialogVisible = false;
    },
    changeScStatus() {
      sendCommandKp('multiple', this.dcInfoCache, "set", {
        methodName: "settingScheduleRunning",
        methodParams: { boolRun: this.isScOpen }
      });
      this.myWebSocket.onmessage = (val) => {
        let res = JSON.parse(val.data);
        if (res.type == "invoke_method" && res.data.uri == 'settingScheduleRunning') {
          let response = JSON.parse(res.data.response);
          if (response.code == 200) {
            this.$msg({
              type: 'success',
              message: this.$t('terminal.opOk')
            })
          } else {
            this.$msg({
              type: 'success',
              message: response.message
            })
            this.isScOpen = !this.isScOpen;
          }
        }
      }
    },
    isScuRun() {
      sendCommandKp('multiple', this.dcInfoCache, "set", {
        methodName: "isScheduleSettingRunning",
        methodParams: {}
      });
      this.myWebSocket.onmessage = (val) => {
        let res = JSON.parse(val.data);
        if (res.type == "invoke_method" && res.data.uri == 'isScheduleSettingRunning') {
          let response = JSON.parse(res.data.response);
          if (response.code == 200) {
            this.isScOpen = response.isRunning
          }
        }
        if (res.type == "get_setting_schedule") {
          this.tableData = res.data ? res.data : [];
          this.tableData.forEach(ele => {
            ele.weeks = daysWeek(ele.validWeek);
            if (ele.action == 7 || ele.action == 8) {
              ele.pcList = powerAndCard(ele.value);
            }
          })
        }
      }
    },
    getScList() {
      this.$http.post(
        detailCommand, {
        commands_info: uriEncode([{
          device_id: this.currentDetail.id,
          sn: this.currentDetail.sn,
          msg: {
            id: this.currentDetail.id,
            sn: this.currentDetail.sn,
            groupName: this.$cookies.get("user_id"),
            type: "get_setting_schedule",
          },
        }]),
      }
      );
    }
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  created() {
    this.dcInfoCache = [{
      id: this.currentDetail.id,
      sn: this.currentDetail.sn,
      type_id: this.currentDetail.type_id,
      name: this.currentDetail.name,
      cache: {}
    }];
    this.getScList();
    this.isScuRun();
  },
}
</script>

<style lang="scss" scoped>
.schedule-list {
  width: 100%;
  height: 100%;

  .table {
    margin: 0 auto;
    width: 98%;
    height: calc(100% - 150px);

    .edit {
      display: flex;
      align-items: center;

      img {
        width: 35px;
        height: 35px;
        cursor: pointer;
      }
    }
  }

  .control {
    height: 140px;
    width: 100%;

    .switch {
      width: 100%;
      height: 40px;
    }

    .button {
      width: 100%;
      height: 100px;
    }
  }
}

.update {
  position: fixed;
  right: 0;
  top: 60%;
}
</style>
